import {
  ExpandableCardsContainer,
  ExpandableCardsContent,
  ExpandableCardsSection,
  ExpandableCardsTitle,
  DescriptionTitleContainer,
} from './styled.expandableCards';
import { useTranslation } from 'react-i18next';
import { DropdownIcon } from '../../../common/icons/DropdownIcon';
import React, { useEffect, useRef, useState } from 'react';
import { IExpandableCard } from '../../../@types/expandableCard';
import { Body5, Headline4 } from '../../../../app/common/typography';

export function ExpandableCard ({
  children,
  columns,
  subject,
  backgroundColorDetail,
  onExpand,
  isLoading,
  isCardOpen,
}: IExpandableCard) {
  const content = useRef<HTMLDivElement>();

  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const [height, setHeight] = useState<string>('0px');

  function toggleExpandableCards () {
    setOpen(!open);
    if (onExpand && !open) {
      onExpand();
    }
    if (content && content.current) {
      setHeight(open ? '0px' : `${content.current.scrollHeight}px`);
    }
  }

  useEffect(() => {
    if (!isCardOpen) {
      setOpen(false);
      setHeight('0px');
    } else {
      setOpen(true);
      if (content && content.current) {
        setHeight(`${content.current.scrollHeight}px`);
      }
    }
  }, [isCardOpen, isLoading]);

  return (
    <ExpandableCardsSection>
      <ExpandableCardsContainer
        onClick={toggleExpandableCards}
        data-testid="expandable-card-toggle"
      >
        {columns.map((column: string | JSX.Element, index: number) => {
          if (index === 0) {
            return (
              <ExpandableCardsTitle key={index} width={50}  data-testid="expandable-card-column">
                <Headline4 ellipsis={true} color="eerieBlack">
                  {column}
                </Headline4>
              </ExpandableCardsTitle>
            );
          } else {
            return (
              <ExpandableCardsTitle key={index}  data-testid="expandable-card-column">
                <Headline4 ellipsis={true} color="eerieBlack">
                  {column}
                </Headline4>
              </ExpandableCardsTitle>
            );
          }
        })}
        <ExpandableCardsTitle>
          <DropdownIcon
            data-testid="expandable-card-dropdown-icon"
            rotate={open ? '180' : '0'}
          />
        </ExpandableCardsTitle>
      </ExpandableCardsContainer>
      {subject && (
        <DescriptionTitleContainer>
          <Body5 color="battleShipGray" data-testid="expandable-card-subject">
            {t('COMMON.MY_AUDIT.LABELS.SUBJECT')}
            {subject}
          </Body5>
        </DescriptionTitleContainer>
      )}
      <ExpandableCardsContent
        ref={content}
        height={height}
        backgroundColorDetail={backgroundColorDetail}
        data-testid="expandable-card-content"
      >
        {children}
      </ExpandableCardsContent>
    </ExpandableCardsSection>
  );
}
